'use strict';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {Button} from '../../../components/buttons/Button';
import {I18nMessage} from '../../../components/I18nMessage';

export function ChatPanelView(props) {
  return (
    <div
      className={classNames("ChatPanel", props.className)}
    >
      <div className="ChatList__header">
        {/* <Button className="IconButton ChatList__headerButton"
                iconClass="icon ion-close"
                onClick={props.onClose}/>*/}
        <span className="ChatList__headerButton" />
        <span className="VideoChat-chat-header-title">
          {props.headerLabel}
        </span>
        <span className="ChatList__headerButton" />
      </div>
      {props.children}
      <div className="ChatPanel__footer">
        <Button
          className="EditButton ChatList__headerButton"
          label={<I18nMessage message="default.okay.label" />}
          onClick={props.onHidePanel}
        />
      </div>
    </div>
  );
}

ChatPanelView.propTypes = {
  className: T.string,
  headerLabel: T.node,
  onClose: T.func,
  onNav: T.func,
  onHidePanel: T.func,
};

ChatPanelView.defaultProps = {
  className: '',
};



// WEBPACK FOOTER //
// ./src/js/comments/components/ChatPanel/ChatPanelView.js